/*
 * View for the intent summary (topic label)
 */

define([
  "marionette",
  "modules/topicsSplit/topic/topicLabel/template/topicLabelTemplate.html",
], function (Marionette, TopicLabelTemplate) {
  var TopicLabelView = {};

  TopicLabelView.topicLabelView = Marionette.ItemView.extend({
    template: TopicLabelTemplate,
    modelEvents: {
      change: "render",
    },
    textboxes: {
      "#labelTextField": {
        enableSelector: "#topicLabel",
        modelAttribute: "summary",
        placeholder: "topic.label.label",
        textArea: false,
      },
    },
    triggers: {
      "click button": "edit:label:modal",
    },
  });

  return TopicLabelView;
});
